// const host = "https://api.enfirad.com/";


// const host = "http://localhost:5000/";
const host = "https://api.enfirad.com/";

export default host